import * as Persona from 'persona'
import * as React from 'react'
import { IdvResult } from './index'

type Props = {
  uniqueLink?: string
  error?: string
  vehicleType?: string
  trackIdentityVerificationSteps: (data: any) => any
  onUpdate?: any
}

type PersonaEvent =
  | 'load'
  | 'start'
  | 'country-select'
  | 'document-camera-select'
  | 'document-camera-capture'
  | 'document-upload'
  | 'verification-change'
  | 'success'

const IdentityVerification: React.FC<Props> = ({
  uniqueLink,
  vehicleType,
  onUpdate,
  trackIdentityVerificationSteps,
}) => {
  React.useEffect(() => {
    const client = new Persona.Client({
      // This refers to a production demo template owned by Persona
      templateId: 'tmpl_dos19dD2bQ9wjrnVjAWRo1Ff',
      environment: 'sandbox',
      referenceId: uniqueLink,
      onLoad: () => client.open(),
      onComplete: (inquiryId: string, scopes) => {
        onUpdate({ isIdentityVerified: IdvResult.PASSED })
      },
      onFail: (inquiryId: string) => {
        onUpdate({ isIdentityVerified: IdvResult.FAILED })
      },
      onExit: (error, metadata) => {
        onUpdate({ isIdentityVerified: IdvResult.NOT_COMPLETED })
      },
      onEvent: (eventName: PersonaEvent, metadata: any) => {
        trackIdentityVerificationSteps({
          step: eventName,
        })
      },
    })
  })

  return null
}

export default IdentityVerification
